import { useLocation } from "react-router-dom";
import React, { useEffect, useState } from 'react';
import ProfileUser from './connectMenuUser/ProfileUser'
import VideoListUser from './connectMenuUser/VideoListUser'

export default function BodyUser() {
     const location = useLocation();
     // Thêm state activeTab để lưu tab đang mở (profile hoặc videoList)
    const [activeTab, setActiveTab] = useState('profile');
    useEffect(() => {
    // Ưu tiên lấy từ location.state, nếu không có thì lấy từ sessionStorage
    const tabFromState = location.state?.activeTab;
    const tabFromSession = sessionStorage.getItem('activeTab');
    if (tabFromState) {
        setActiveTab(tabFromState);
        sessionStorage.setItem('activeTab', tabFromState);
    } else if (tabFromSession) {
        setActiveTab(tabFromSession);
    }
}, [location.state]);
// Khi user click tab, cũng lưu vào sessionStorage
const handleSetTab = (tab) => {
    setActiveTab(tab);
    sessionStorage.setItem('activeTab', tab);
};
    return (
        <div className="bodyUser">
            <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                    <button 
                             // Sử dụng activeTab để xác định tab nào đang active
                            className={`nav-link${activeTab === 'profile' ? ' active' : ''}`}
                            id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" 
                            type="button" role="tab" aria-controls="profile" aria-selected={activeTab === 'profile'}
                            onClick={() => handleSetTab('profile')}
                    >
                        Giới thiệu
                    </button>
                </li>
                <li className="nav-item" role="presentation">
                    <button 
                            className={`nav-link${activeTab === 'videoList' ? ' active' : ''}`}
                            id="videoList-tab" data-bs-toggle="tab" data-bs-target="#videoList" 
                            type="button" role="tab" aria-controls="videoList" aria-selected={activeTab === 'videoList'}
                            onClick={() => handleSetTab('videoList')}
                    >
                        Khóa Học
                    </button>
                </li>
            </ul>
            <div className="tab-content">
                <div className={`tab-pane${activeTab === 'profile' ? ' show active' : ''}`} id="profile" role="tabpanel" aria-labelledby="profile-tab">
                    <ProfileUser/>
                </div>
                
                <div className={`tab-pane${activeTab === 'videoList' ? ' show active' : ''}`} id="videoList" role="tabpanel" aria-labelledby="videoList-tab">
                    <VideoListUser/>
                </div>
                
            </div>
        </div>
    )
}
